import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
} from "@certn/cascadia-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type GroupActiveToggleModalProps = {
  onClose: () => void;
};

export function ExitGroupCreateModal({ onClose }: GroupActiveToggleModalProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleLeave = async () => {
    navigate(`/groups`);
  };
  return (
    <Modal isOpen>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Are you sure?")}</DialogHeader>
        <DialogContent>
          {t("Are you sure you want to leave? Your progress won't be saved.")}
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <BasicButton size="medium" onPress={onClose}>
              {t("Cancel")}
            </BasicButton>
            <PrimaryButton
              size="medium"
              onPress={handleLeave}
              testID="leave-group-create"
            >
              {t("Leave")}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
